// importando biblioteca
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// importando estilos
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import fundo from "../../../styles/fundo.svg";
import fundo2 from "../../../styles/fundo2.svg";
import GlobalStyle from "../../../styles/global.js";
import logo from "../../../styles/imagem/Logomarca-06.png";

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh; /* Faz o Div ocupar 100% da altura da viewport */
  background-image: url(${fundo2});
 overflow: visible;
`;
const FormContainer = styled.form`
  width: 100%;
  max-width: 440px;
  background-color: white;
  display: flex; 
  justify-content: center; 
  align-items: center;
  padding: 0px 10px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 10px 10px 10px 10px;
  gap: 5px;
  flex-direction: column;
  margin: auto;

  @media (max-width: 1360px) {
    max-width: 440px;
    justify-content: space-between; 
  }
  @media (max-width: 1024px) {
    width: 440px;
    justify-content: space-between; 
  }
  @media (max-width: 640px) {
    width: 380px;
    justify-content: space-between; 
  }
  @media (max-width: 480px) {

    width: 340px;
    justify-content: space-between; 
  }
  @media (max-width: 376px) {
    width: 320px;
  }
`;
const Title = styled.h1`
  font-size: 34px;
  color: #545454;
  margin-bottom: 5px;
  font-family: "Arial", sans-serif;

  display: flex;
  justify-content: center; 
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media (max-width: 480px) {
    font-size: 32px;       /* Reduz o tamanho da fonte */
    margin: 0;            /* Remove a margem */
    text-align: center;   /* Centraliza o texto */
  }

  @media (max-width: 400px) {
    font-size: 30px;       /* Reduz mais o tamanho da fonte */
    margin: 0;            /* Remove a margem */
    text-align: center;   /* Centraliza o texto */
  }
`;
const Input = styled.input`
  font-family: "Open Sans", sans-serif;
  width: 94%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #076633;
  }
`;
const Button = styled.button`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  background-color: #a5adb0;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-image: url(${fundo});
  }
`;
const Div2 = styled.div`
  padding-top: 30px;
  display: flex;
  justify-content: center; 
  flex-direction: column;

`;
const Label = styled.label`

  padding-top: 25px;
  font-weight: bold;
  font-size: 17px;
  text-align: left;
  color: #808080;
  
  p{
    color: #4f4f4f;
  }
  

`;
const ForgotPassword = styled.p`
  font-size: 14px;
  color: #333;
  cursor: pointer;
  text-decoration: underline;
`;


const Title3 = styled.nav`
  height: 6rem;
  width: 460px;
  background-image: url(${fundo});
  background-size: cover;
  background-position: center;
  border-radius: 10px 10px 0px 0px;



  @media (max-width: 640px) {
    width: 400px;
  }
  @media (max-width: 480px) {
    width: 360px;
  }
  @media (max-width: 400px) {
    width: 360px;
  }
`;
const Title2 = styled.h2`
  color: #fff;
  font-size: 28px;
  display: flex;
  justify-content: center; /* Centraliza o conteúdo horizontalmente */
  align-items: center; /* Centraliza o conteúdo verticalmente */
  height: 100%;
  height: 6rem;
 
  div {
    display: flex;
    justify-content: center; /* Centraliza horizontalmente */
    align-items: center; /* Centraliza verticalmente */
    width: 100%; /* Opcional: Garante que o div ocupe toda a largura disponível */
    height: 100%;
  }
`;


const VerificarToken = ({ login }) => {

  const urlApi = process.env.REACT_APP_API_URL;


  //--------------------------------------------------------------------------------------------------------------//
  const [tokenLogin, setTokenLogin] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [novaSenha, setNovaSenha] = useState('');
  const [novaSenhaNovamente, setNovaSenhaNovamente] = useState('');

  //--------------------------------------------------------------------------------------------------------------//
  const handleVerifyToken = async () => {
    if (!tokenLogin) {
      toast.error('Por favor, insira o token.');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${urlApi}logon/verificar-token-senha/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ logon: login.toUpperCase(), token: tokenLogin }),
      });

      const textResponse = await response.text();
      const data = JSON.parse(textResponse);
      const id = data.id_usuario;

      if (response.ok) {
        handleLogin();
        await logEvento(id, `Token validado com sucesso!`);
      } else {
        toast.error(data.error || 'Erro desconhecido ao validar o token.');
        await logEvento(id, `Erro ao validar o token: ${data.error}`);
      }
    } catch (error) {
      toast.error('Erro ao validar o token. Tente novamente.');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };


  //--------------------------------------------------------------------------------------------------------------//

  const handleLogin = async () => {
    if (!novaSenha || !novaSenhaNovamente) {
      return toast.error("Os campos de senha não podem estar vazios!");
    }

    if (novaSenha !== novaSenhaNovamente) {
      return toast.error("As novas senhas não coincidem!");
    }

    try {
      const response = await axios.put(`${urlApi}logon/trocar-senha/${login}`, {
        senha: novaSenha,
      });

      const data = response.data;
      const id = data.id_usuario;

      if (response.status === 200) {
        toast.success("Senha alterada com sucesso!");
        await logEvento(id, "Senha alterada com sucesso.");
        setTimeout(() => window.location.href = '/login', 1500);
      } else {
        toast.error("Erro ao alterar a senha.");
        await logEvento(id, "Falha ao alterar a senha (status inesperado).");
      }

    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Erro desconhecido.';
      const id = error.response?.data?.id_usuario || null;

      console.error("Erro ao trocar senha:", errorMessage);
      toast.error(errorMessage);
      await logEvento(id, `Erro ao alterar senha: ${errorMessage}`);
    }
  };


  //--------------------------------------------------------------------------------------------------------------//

  //Função 'reenviar token'
  const [tempoRestante, setTempoRestante] = useState(0);
  const [bloqueado, setBloqueado] = useState(false);
  const [intervaloId, setIntervaloId] = useState(null);

  useEffect(() => {
    if (tempoRestante === 0 && intervaloId) {
      clearInterval(intervaloId);
      setBloqueado(false);
      setIntervaloId(null);
    }
  }, [tempoRestante]);

  const reenviarToken = async () => {
    if (bloqueado) return; // Impede múltiplos cliques

    try {
      const response = await fetch(`${urlApi}logon/enviar-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ login }),
      });

      const textResponse = await response.text();
      const data = JSON.parse(textResponse);
      const id = data.id_usuario;

      if (!response.ok) {
        toast.error(data.error || "Erro ao enviar o token.");
        await logEvento(id, `Erro ao reenviar o token: ${data.error || 'Erro desconhecido'}`);
        return;
      }

      toast.success(data.mensagem);
      await logEvento(id, 'Token reenviado com sucesso!');


      // Inicia o contador de 15 minutos (900 segundos)
      setTempoRestante(900);
      setBloqueado(true);

      const novoIntervalo = setInterval(() => {
        setTempoRestante((tempoAnterior) => {
          if (tempoAnterior <= 1) {
            clearInterval(novoIntervalo);
            setBloqueado(false);
            return 0;
          }
          return tempoAnterior - 1;
        });
      }, 1000);

      setIntervaloId(novoIntervalo);


    } catch (error) {
      alert("Erro de rede ou erro desconhecido.");
    }
  };


  //--------------------------------------------------------------------------------------------------------------//


  const logEvento = async (id, descricao) => {
    try {
      const logData = {
        COD_FUNCIONARIO: id,
        DESC_LOG: descricao,
      };

      const response = await fetch(`${urlApi}logon/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(logData),
      });

      if (!response.ok) {
        throw new Error('Failed to save log');
      }
    } catch (error) {
      console.error('Erro ao salvar log:', error);
    }
  };

  //--------------------------------------------------------------------------------------------------------------//

  return (
    <Div >
      <FormContainer>
        <Title3 >
          <Title2>
            <div>
              <img src={logo} alt="Logo" />
            </div>
          </Title2>
        </Title3>
        <Title>Redefinir senha</Title>


        <Div2>
          <div>
            <Label>Digite o token:</Label>
            <Input
              type="text"
              placeholder="Digite o token recebido por e-mail"
              value={tokenLogin}
              onChange={(e) => setTokenLogin(e.target.value)}
            />

            <ForgotPassword onClick={!bloqueado ? reenviarToken : undefined} disabled={bloqueado}>
              {bloqueado
                ? `Reenviar novamente em ${Math.floor(tempoRestante / 60)}:${(tempoRestante % 60).toString().padStart(2, "0")}`
                : "Reenviar token"}
            </ForgotPassword>
          </div>
        </Div2>
        <Div2>

          <div>
            <Label>Nova senha:</Label>

            <Input
              type="password"
              placeholder="Digite aqui..."
              onChange={(e) => setNovaSenha(e.target.value)}
            />
          </div>
          <div>
            <Label>Repetir nova senha:</Label>
            <Input
              type="password"
              placeholder="Digite aqui..."
              onChange={(e) => setNovaSenhaNovamente(e.target.value)}
            />
          </div>

        </Div2>
        <Button type='button' onClick={handleVerifyToken} disabled={isSubmitting}>
          {isSubmitting ? 'Salvando...' : 'Salvar'}
        </Button>
      </FormContainer>
      <GlobalStyle />
      <ToastContainer
        autoClose={1500}
        position={toast.POSITION.BOTTOM_LEFT}
        style={{ width: '400px', fontSize: '22px' }}
      />
    </Div>
  );
};

export default VerificarToken;
